import { RESCUE_LIST_UPDATE, RESCUE_POPUP_UPDATE } from '../mutationTypes';

const initState = {
  rescueList: [],
  popupStatus: false,
};

const state = JSON.parse(JSON.stringify(initState));

const mutations = {
  [RESCUE_LIST_UPDATE](stateObj, newValue) {
    const states = stateObj;
    states.rescueList = newValue;
  },
  [RESCUE_POPUP_UPDATE](stateObj, newValue) {
    const states = stateObj;
    states.popupStatus = newValue;
  },
};

const actions = {
  async fetch_rescueList({ commit }, value) {
    commit(RESCUE_LIST_UPDATE, value);
  },
};

export default {
  name: 'rescue',
  namespaced: true,
  state,
  mutations,
  actions,
};
